import { useRouter } from 'next/router';
import { convertStrToDate } from '../../lib/date';

const PostMeta = ({ post, className = '', link = true }) => {
  const router = useRouter();
  return (
    <div className={`${className} whitespace-nowrap`}>
      {convertStrToDate(
        post.publish_date1
          ? post.publish_date1
          : post._meta.firstPublicationDate,
      )}
    </div>
  );
};

export default PostMeta;
